import { http } from '@/http'

export default {
  createPeriod(data) {
    return http.post('/payroll-engine/create', data)
  },
  calculate(id, attendanceOverrideConfirmed = false) {
    // Guard 3 (DEF-013): attendanceOverrideConfirmed=true salta el bloqueo por días sin registro.
    return http.post(`/payroll-engine/${id}/calculate`, null,
      { params: attendanceOverrideConfirmed ? { attendanceOverrideConfirmed: true } : {} })
  },
  approve(id, complianceOverrideConfirmed = false) {
    // DEF documentación incompleta: complianceOverrideConfirmed=true confirma aprobar aunque haya
    // colaboradores con documentos faltantes (se incluyen y pagan igual).
    return http.post(`/payroll-engine/${id}/approve`, null,
      { params: complianceOverrideConfirmed ? { complianceOverrideConfirmed: true } : {} })
  },
  pay(id, paidAt) {
    return http.post(`/payroll-engine/${id}/pay`, null, { params: { paidAt } })
  },
  annul(id) {
    return http.post(`/payroll-engine/${id}/annul`)
  },
  recalculate(id) {
    return http.post(`/payroll-engine/${id}/recalculate`)
  },
  get(id) {
    return http.get(`/payroll-engine/${id}`)
  },
  getDetails(id) {
    return http.get(`/payroll-engine/${id}/details`)
  },
  list(companyId, year) {
    return http.get('/payroll-engine', { params: { companyId, year } })
  },
  exportExcel(id) {
    return http.get(`/payroll-engine/${id}/export`, { responseType: 'blob' })
  },
  // DEF-018: boletas de pago (solo planilla PAGADA).
  downloadPayslip(detailId) {
    return http.get(`/payroll-details/${detailId}/payslip`, { responseType: 'blob' })
  },
  downloadPayslipsZip(payrollId) {
    return http.get(`/payroll-engine/${payrollId}/payslips`, { responseType: 'blob' })
  },
  employeePayslips(employeeId) {
    return http.get(`/payroll-engine/employee/${employeeId}/payslips`)
  },
  // DEF-019 (avance parcial): preview + validación pre-export de PLAME (solo APROBADA/PAGADA).
  plamePreview(id) {
    return http.get(`/payroll-engine/${id}/plame/preview`)
  },
  // DEF-019: ZIP con los 4 archivos del PDT PLAME (.jor, .snl, .rem, .toc).
  plameExport(id) {
    return http.get(`/payroll-engine/${id}/plame/export`, { responseType: 'blob' })
  },
  // DEF-020 (avance parcial): pagos masivos bancarios.
  paymentFileBanks(id) {
    return http.get(`/payroll-engine/${id}/payment-file/banks`)
  },
  paymentFilePreview(id) {
    return http.get(`/payroll-engine/${id}/payment-file/preview`)
  },
  getMovementsByEmployeePeriod(employeeId, year, month) {
    return http.get(`/payroll-movements/employee/${employeeId}`, { params: { year, month } })
  },
  // DEF-005: ajuste manual del IR 5ta de un detalle (solo en planilla CALCULADA).
  overrideIr(detailId, amount, reason) {
    return http.put(`/payroll-details/${detailId}/ir-override`, { amount, reason })
  },
}
